export const PREMIUM_COMPANY_IDS: string[] = ['66', '122168'] as const;
